import { useState } from "react";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";

const field = "w-full bg-white border border-[#e2dcd4] px-4 py-3 text-[15px] focus:outline-none focus:border-[#1f402b] transition-colors";
const SUBJECTS = ["General", "Venue or location info", "Image removal request", "Media", "Correction"];

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "General", message: "" });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/enquiries", form);
      setSent(true);
      toast.success("Thanks — your enquiry has been received.");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-14 sm:pt-20 grid lg:grid-cols-12 gap-12" data-testid="contact-page">
      <div className="lg:col-span-5">
        <p className="eyebrow rise">Contact</p>
        <h1 className="rise d1 mt-4 text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#1a261f]">Say kia ora.</h1>
        <p className="rise d2 mt-6 text-[#5a665e] leading-relaxed max-w-md">
          Questions about naturism in New Zealand, venue suggestions, corrections or image removal requests — we read everything and reply personally.
        </p>
      </div>
      <div className="lg:col-span-6 lg:col-start-7">
        {sent ? (
          <div className="border border-[#e2dcd4] bg-white p-10" data-testid="contact-success">
            <CheckCircle2 className="text-[#3d644e]" />
            <h2 className="mt-4 text-3xl text-[#1f402b]">Message received.</h2>
            <p className="mt-3 text-[#5a665e]">We'll be in touch at {form.email}.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-5" data-testid="contact-form">
            <div className="grid sm:grid-cols-2 gap-5">
              <input required placeholder="Your name" value={form.name} onChange={set("name")} className={field} data-testid="contact-name-input" />
              <input required type="email" placeholder="Email" value={form.email} onChange={set("email")} className={field} data-testid="contact-email-input" />
            </div>
            <select value={form.subject} onChange={set("subject")} className={field} data-testid="contact-subject-select">
              {SUBJECTS.map((s) => <option key={s}>{s}</option>)}
            </select>
            <textarea required minLength={5} rows={7} placeholder="Your message" value={form.message} onChange={set("message")} className={field} data-testid="contact-message-input" />
            <button disabled={sending} className="bg-[#1f402b] text-white px-8 py-3.5 text-sm tracking-wide hover:bg-[#2c5a3d] disabled:opacity-60 transition-colors" data-testid="contact-form-submit">
              {sending ? "Sending…" : "Send enquiry"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
